export default __webpack_public_path__ + "static/media/y-axis.220261d0.svg";